import { render, staticRenderFns } from "./PerguntasIcmsSt.vue?vue&type=template&id=1843bf15&scoped=true&"
import script from "./PerguntasIcmsSt.vue?vue&type=script&lang=js&"
export * from "./PerguntasIcmsSt.vue?vue&type=script&lang=js&"
import style0 from "./PerguntasIcmsSt.vue?vue&type=style&index=0&id=1843bf15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1843bf15",
  null
  
)

export default component.exports